import { render, staticRenderFns } from "./PriceControl.vue?vue&type=template&id=c5eecb82&scoped=true&"
import script from "./PriceControl.vue?vue&type=script&setup=true&lang=js&"
export * from "./PriceControl.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PriceControl.vue?vue&type=style&index=0&id=c5eecb82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5eecb82",
  null
  
)

export default component.exports